import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useExcessReturnContext from 'contexts/excess-returns.context/context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ENUM_RETURNS_STATUS } from 'models/common.model';
import ReturnsStatusTag from 'components/base/returns-status-tag';
import useDashboardContext from 'contexts/dashboard.context';

const ExcessReturnsDetails = () => {
  const { excessReturnToUpdate } = useExcessReturnContext();
  const [isCompletingExcessReturn, setIsCompletingExcessReturn] = useState(false);
  const router = useNavigate();
  const { setIsBackLink, setBackLinkTitle, activeStore } = useDashboardContext();

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to procurement');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const confirmReturns = async () => {
    if (!activeStore?.id) return;
    try {
      setIsCompletingExcessReturn(true);
      const response = await apiService.post(
        `kitchen-store/stores/${activeStore.id}/confirm-return/${excessReturnToUpdate.id}`
      );
      if (response) {
        toast(<ToastMessage message='Excess return completed successfully' type='success' />);
        router(-1);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error completing excess return'}
          type='error'
        />
      );
    } finally {
      setIsCompletingExcessReturn(false);
    }
  };
  const is_completed = excessReturnToUpdate.status === ENUM_RETURNS_STATUS.COMPLETED;

  return (
    <div>
      <div className='flex items-center'>
        <h4 className='text-[24px] font-semibold text-[#2E3031] mr-2'>
          Return #{excessReturnToUpdate.id.substring(0, 5)}
        </h4>
        <ReturnsStatusTag
          type={is_completed ? ENUM_RETURNS_STATUS.COMPLETED : ENUM_RETURNS_STATUS.CREATED}
        />
      </div>
      <p className='text-[#6F7376] text-sm mb-8'>Manage excess returns by kitchen store</p>
      <div className='border-4 border-[#F7F7F8] rounded py-[24px]  md:max-w-[670px]'>
        <div className='flex justify-between px-[28px]'>
          <div className=' pb-5'>
            <p className='font-semibold text-[24px] '>
              {is_completed ? 'Completed' : 'Confirm'} excess returns
            </p>
            <p className='text-[#6F7376] text-sm'>Certain items were returned, ensure to cofirm</p>
          </div>
        </div>
        {excessReturnToUpdate.items.map((item, index) => (
          <div
            className='flex justify-between py-[24px] px-[28px] border-b border-b-[#F7F7F8]'
            key={index}>
            <div>
              <p className='text-[16px] font-semibold pb-[4px] capitalize'>
                {item.ingredient.name}
              </p>
              <p className='font-medium'>
                {item.quantity} {item.ingredient.unit_type}
              </p>
            </div>
          </div>
        ))}
        <div>
          <hr className='border-t-4 border-[#F7F7F8]' />
          {is_completed ? (
            <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
              <Button
                variant='block'
                color='primary'
                small
                className='w-[153px] h-[43px]'
                onClick={() => router(-1)}>
                Back
              </Button>
            </div>
          ) : (
            <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
              <Button variant='link' color='gray' small>
                Cancel
              </Button>
              <Button
                variant='block'
                color='primary'
                small
                className='w-[153px] h-[43px]'
                onClick={() => confirmReturns()}
                loading={isCompletingExcessReturn}>
                Confirm
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExcessReturnsDetails;
